import { ConsolidatedLocationView } from '@mark43/cad-api';
import { cssVar, HStack, Button, Spinner, Text } from '@cad-arc';
import { PREFILLED_WITH_UNIT_GPS_LOCATION_MESSAGE } from './constants';

export function FrEventLocationManualGpsPrefillContent({
    isPrefilledWithUnitGpsLocation,
    isLoading,
    closestLocationForManualPrefill,
    manuallyPrefillFormLocationWithClosestLocation,
}: {
    isPrefilledWithUnitGpsLocation: boolean;
    isLoading: boolean;
    closestLocationForManualPrefill?: ConsolidatedLocationView;
    manuallyPrefillFormLocationWithClosestLocation: () => void;
}) {
    if (isLoading) {
        return <Spinner size="sm" />;
    }

    if (!closestLocationForManualPrefill) {
        return null;
    }

    if (isPrefilledWithUnitGpsLocation) {
        return (
            <Text isItalic fontSize="md">
                {PREFILLED_WITH_UNIT_GPS_LOCATION_MESSAGE}
            </Text>
        );
    }

    return (
        <HStack
            padding={`0 0 0 ${cssVar('arc.space.1')}`}
            alignItems="center"
            style={{ margin: 0 }}
            width="100%"
        >
            <Text isItalic fontSize="md">
                Manually entered location
            </Text>
            <Button
                leadingVisual="TransmitData"
                onClick={manuallyPrefillFormLocationWithClosestLocation}
                variant="ghost"
                style={{ margin: 0 }}
            >
                Device GPS
            </Button>
        </HStack>
    );
}
